'use strict';

import * as Blockly from 'blockly/core';

// Any imports need to be reserved words
Blockly.Python.addReservedWords('grove');


Blockly.Python['grove_button'] = function(block) {
  Blockly.Python.definitions_['import_grove'] = Blockly.Python.refinedImport('import_grove', 'Button');
  let pin = block.getFieldValue('pin');
  let code = `Button(pin${pin})`;
  Blockly.Python.definitions_['import_microbit'] = Blockly.Python.refinedImport('import_microbit',`pin${pin}`);
  return [code, Blockly.Python.ORDER_MEMBER];
};

Blockly.Python['grove_button_is_pressed'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return [`${grove_var}.is_pressed()`, Blockly.Python.ORDER_NONE];
};

Blockly.Python['grove_joystick'] = function(block) {
  Blockly.Python.definitions_['import_grove'] = Blockly.Python.refinedImport('import_grove', 'Joystick');
  let xpin = block.getFieldValue('pin1');
  let ypin = block.getFieldValue('pin2');
  let code = `Joystick(pin${xpin}, pin${ypin})`;
  Blockly.Python.definitions_['import_microbit'] = Blockly.Python.refinedImport('import_microbit', `pin${xpin}`);
  Blockly.Python.definitions_['import_microbit'] = Blockly.Python.refinedImport('import_microbit', `pin${ypin}`);
  return [code, Blockly.Python.ORDER_MEMBER];
};

Blockly.Python['grove_joystick_get_x'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return [`${grove_var}.get_x()`, Blockly.Python.ORDER_NONE];
};

Blockly.Python['grove_joystick_get_y'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return [`${grove_var}.get_y()`, Blockly.Python.ORDER_NONE];
};

Blockly.Python['grove_minimotor'] = function(block) {
  Blockly.Python.definitions_['import_grove'] = Blockly.Python.refinedImport('import_grove', 'MiniMotor');
  let motornum = block.getFieldValue('motornum');
  let code = `MiniMotor(${motornum})`;
  return [code, Blockly.Python.ORDER_MEMBER];
};

Blockly.Python['grove_minimotor_get_address'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return [`${grove_var}.getAddress()`, Blockly.Python.ORDER_NONE];
};

Blockly.Python['grove_minimotor_get_fault'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return [`${grove_var}.getFault()`, Blockly.Python.ORDER_NONE];
};

Blockly.Python['grove_minimotor_clear_fault'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return `${grove_var}.clearFault()\n`;
};

Blockly.Python['grove_minimotor_stop'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return `${grove_var}.stop()\n`;
};

Blockly.Python['grove_minimotor_brake'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return `${grove_var}.brake()\n`;
};

Blockly.Python['grove_minimotor_set_speed'] = function(block) {
  let speed = block.getFieldValue('speed');
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return `${grove_var}.setSpeed(${speed})\n`;
};

Blockly.Python['grove_moisture'] = function(block) {
  Blockly.Python.definitions_['import_grove'] = Blockly.Python.refinedImport('import_grove', 'Moisture');
  let pin = block.getFieldValue('pin1');
  let code = `Moisture(pin${pin})`;
  Blockly.Python.definitions_['import_microbit'] = Blockly.Python.refinedImport('import_microbit',`pin${pin}`);
  return [code, Blockly.Python.ORDER_MEMBER];
};

Blockly.Python['grove_moisture_get'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return [`${grove_var}.get()`, Blockly.Python.ORDER_NONE];
};

Blockly.Python['grove_servo'] = function(block) {
  Blockly.Python.definitions_['import_grove'] = Blockly.Python.refinedImport('import_grove', 'Servo');
  let pin = block.getFieldValue('pin1');
  let code = `Servo(pin${pin})`;
  Blockly.Python.definitions_['import_microbit'] = Blockly.Python.refinedImport('import_microbit',`pin${pin}`);
  return [code, Blockly.Python.ORDER_MEMBER];
};

Blockly.Python['grove_servo_set'] = function(block) {
  let angle = block.getFieldValue('angle');
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return `${grove_var}.set(${angle})\n`;
};

Blockly.Python['grove_sound'] = function(block) {
  Blockly.Python.definitions_['import_grove'] = Blockly.Python.refinedImport('import_grove','sound');
  let pin = block.getFieldValue('pin1');
  let code = `Sound(pin${pin})`;
  Blockly.Python.definitions_['import_microbit'] = Blockly.Python.refinedImport('import_microbit',`pin${pin}`);
  return [code, Blockly.Python.ORDER_MEMBER];
};

Blockly.Python['grove_sound_get'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return [`${grove_var}.get()`, Blockly.Python.ORDER_NONE];
};

Blockly.Python['grove_sunlight'] = function(block) {
  Blockly.Python.definitions_['import_grove'] = Blockly.Python.refinedImport('import_grove', 'Sunlight');
  let code = 'Sunlight()';
  return [code, Blockly.Python.ORDER_MEMBER];
};

Blockly.Python['grove_sunlight_get_visible'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return [`${grove_var}.getVisible()`, Blockly.Python.ORDER_NONE];
};

Blockly.Python['grove_sunlight_get_ir'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return [`${grove_var}.getIR()`, Blockly.Python.ORDER_NONE];
};

Blockly.Python['grove_sunlight_get_uv'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return [`${grove_var}.getUV()`, Blockly.Python.ORDER_NONE];
};

Blockly.Python['grove_ultrasonic'] = function(block) {
  Blockly.Python.definitions_['import_grove'] = Blockly.Python.refinedImport('import_grove', 'UltrasonicRanger');
  let pin = block.getFieldValue('pin1');
  let code = `UltrasonicRanger(pin${pin})`;
  Blockly.Python.definitions_['import_microbit'] = Blockly.Python.refinedImport('import_microbit',`pin${pin}`);
  return [code, Blockly.Python.ORDER_MEMBER];
};

Blockly.Python['grove_ultrasonic_get'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return [`${grove_var}.get()`, Blockly.Python.ORDER_NONE];
};

Blockly.Python['grove_vibration'] = function(block) {
  Blockly.Python.definitions_['import_grove'] = Blockly.Python.refinedImport('import_grove', 'VibrationMotor');
  let pin = block.getFieldValue('pin1');
  let code = `VibrationMotor(pin${pin})`;
  Blockly.Python.definitions_['import_microbit'] = Blockly.Python.refinedImport('import_microbit',`pin${pin}`);
  return [code, Blockly.Python.ORDER_MEMBER];
};

Blockly.Python['grove_vibration_set'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  let val = block.getFieldValue('val');
  if (val == 'True') return `${grove_var}.on()\n`;
  else return `${grove_var}.off()\n`;
};

Blockly.Python['grove_weather'] = function(block) {
  Blockly.Python.definitions_['import_grove'] = Blockly.Python.refinedImport('import_grove', 'Weather');
  let code = 'Weather()';
  return [code, Blockly.Python.ORDER_MEMBER];
};

Blockly.Python['grove_weather_get_temperature'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return [`${grove_var}.getTemperature()`, Blockly.Python.ORDER_NONE];
};

Blockly.Python['grove_weather_get_pressure'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return [`${grove_var}.getPressure()`, Blockly.Python.ORDER_NONE];
};

Blockly.Python['grove_weather_get_humidity'] = function(block) {
  let grove_var = Blockly.Python.variableDB_.getName(block.getFieldValue('grove_var'), Blockly.Variables.NAME_TYPE);
  return [`${grove_var}.getHumidity()`, Blockly.Python.ORDER_NONE];
};
